import { IFullCardProps } from "../../properties/CardProperties";

const FullCard = ({
  backgroundColor,
  borderColor,
  opacity,
  usePadding,
  bare,
  children,
}: IFullCardProps) => {
  return (
    <div
      className={`fc-card ${bare ? "fc-bare" : ""} ${
        backgroundColor ? backgroundColor : "fc-bg-default"
      } ${borderColor ? borderColor : "fc-border-default"} ${
        opacity ? opacity : "fc-opacity-default"
      }`}
    >
      <div className={`fc-body ${usePadding === false ? "fc-pad-0" : "fc-pad-6"}`}>
        {children}
      </div>
    </div>
  );
};

export default FullCard;
